import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import ImgMediaCard from './ImgMediaCard';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: 'var(--white)',
    width: '100vh',
  },
  gridList: {
    maxWidth: 560,
    margin: 'auto',
  },
});

function ImageGridList({ cards, checked, selectCardFunc, classBox }) {
  const selectCard = (card) => {
    return selectCardFunc(card);
  };

  return (
    <div>
      <GridList style={{ height: 'auto', margin: 0 }} className={classBox}>
        {cards.map((card, index) => (
          <GridListTile
            key={index}
            style={{
              height: 'auto',
              padding: index % 2 === 0 ? '4.5px 2.5px' : '4.5px 2.5px',
              // borderRadius: 5,
            }}
          >
            <ImgMediaCard
              card={card}
              selectCardinGrid={(card) => {
                selectCard(card);
              }}
            />
          </GridListTile>
        ))}
      </GridList>
    </div>
  );
}

ImageGridList.propTypes = {
  classes: PropTypes.object.isRequired,
  classBox: PropTypes.string
};

export default withStyles(styles)(ImageGridList);
